import React, { FunctionComponent } from 'react';
import { CustomAlertResponse, SendOutBatchTemplate } from '../models';
import MBSTemplate from './MBSTemplate';

interface MBSTemplateSelectorProps {
  templates: SendOutBatchTemplate[],
  customTemplates: CustomAlertResponse[],
  onSelectTemplate: (templateId: number) => void,
  onSelectCustomTemplate: (templateId: number) => void,
  selectedId: string,
  messageTemplateIsFlashing: boolean,
  translations?: Record<string, string>
}
function chunkArray<T>(array: T[] | undefined | null, size: number): T[][] {
  if (!Array.isArray(array)) {
    return [];
  }

  if (!Number.isInteger(size) || size <= 0) {
    return [];
  }

  const result: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

const MBSTemplateSelector: FunctionComponent<MBSTemplateSelectorProps> = ({
  templates,
  customTemplates,
  onSelectTemplate,
  onSelectCustomTemplate,
  selectedId,
  messageTemplateIsFlashing,
  translations
}) => {
  return (
    <div style={{ paddingLeft: 20, paddingRight: 20 }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: '18px', marginBottom: 20, color: 'grey', marginTop: 20 }}>
          {translations.selectAlertType || "Select alert type"}
        </label>
        <label style={{ color: 'grey', marginBottom: 10 }}>
          {translations.default || "Default"}
        </label>
      </div>

      {/* Default Templates */}
      <ul className="template-selector-wrapper">
        {templates.map((template, index) => (
          <li key={`default-${template.id}`}>
            <MBSTemplate
              id={template.id}
              title={template.title}
              description={template.description}
              flashing={messageTemplateIsFlashing && index === 0}
              replyRequired={template.replyRequired}
              onSelectTemplate={onSelectTemplate}
              selected={selectedId === `default-${template.id}`}
              templateType="default"
            />
          </li>
        ))}
      </ul>

      {/* Custom Templates */}
      {customTemplates?.length > 0 && (
        <label style={{ marginTop: 20, marginBottom: 10, color: 'grey', display: 'flex' }}>
          {translations.custom || "Custom"}
        </label>
      )}
<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
  {chunkArray(customTemplates, 2).map((row, rowIndex) => (
    <div key={`row-${rowIndex}`} style={{ display: 'flex', gap: '1rem' }}>
      {row.map((template, index) => (
        <MBSTemplate
          key={`custom-${template.Id}`}
          id={template.Id}
          title={template.Name}
          description={template.Description}
          flashing={messageTemplateIsFlashing && index === 0 && rowIndex === 0}
          replyRequired={template.ResponseRequired}
          onSelectCustomTemplate={onSelectCustomTemplate}
          selected={selectedId === `custom-${template.Id}`}
          templateType="custom"
        />
      ))}
    </div>
  ))}
</div>
    </div>
  );
};

export default MBSTemplateSelector;
